export { default } from './SafeAnchor';
